var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5445_83018",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5445_83018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.885 21.8828H3.11498C1.78294 21.8828 0.703125 20.803 0.703125 19.471V10.1736C0.703125 8.84153 1.78294 7.76172 3.11498 7.76172H20.885C22.2171 7.76172 23.2969 8.84153 23.2969 10.1736V19.471C23.2969 20.803 22.2171 21.8828 20.885 21.8828Z",
    stroke: "",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.76367 4.9375H3.52734V7.76172H7.76367V4.9375Z",
    stroke: "",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17578 2.11328H2.11523V4.9375H9.17578V2.11328Z",
    stroke: "",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52734 12.9414C4.93941 12.9414 4.93941 13.8789 6.35147 13.8789C7.76348 13.8789 7.76348 12.9414 9.1755 12.9414C10.5876 12.9414 10.5876 13.8789 11.9997 13.8789C13.4118 13.8789 13.4118 12.9414 14.8239 12.9414C16.2361 12.9414 16.2361 13.8789 17.6483 13.8789C19.0605 13.8789 19.0605 12.9414 20.4727 12.9414",
    stroke: "",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.16a94d5ba6a7dc7a999daaad3c7ffe7e.svg";
export { ForwardRef as ReactComponent };